import axios from "axios";
import { environment } from "../../../environments/environment";

export function getKits(part, orderBy = "") {
    return axios.post(`${environment.getKits}?page=${0}&pageSize=${200}&orderBy=${orderBy}`, [{"columnName": "kitId", value: part.id}]);
}

export function saveKitItem(kitItem){
    return axios.post(`${environment.saveKit}`, kitItem)
}

export function deleteKitItem(kitItem){
    return axios.delete(`${environment.deleteKit}?id=${kitItem.id}`,)
}